export default __webpack_public_path__ + "static/media/business-model-canvas.b4d275d9.pdf";